import Vue from "vue";

import CodeInput from "./CodeInput.vue";
import PercentageInput from "./PercentageInput.vue";
import ControlInput from "./ControlInput.vue";

Vue.component("code-input", CodeInput);
Vue.component("control-input", ControlInput);
Vue.component("percentage-input", PercentageInput);
